import React, { useEffect, useState } from 'react';
import {
  ActivityIndicator, ImageBackground, ScrollView, View,
} from 'react-native';
import { Colors } from 'react-native-paper';
import Icon from 'react-native-vector-icons/Ionicons';
import { useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { appColors } from '../../../assets/styles/global';
import { AppHeader } from '../../../components/common';
import { AppText } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import { API } from '../../../service/api';
import styles from './styles';

// eslint-disable-next-line no-unused-vars
const Challenges = ({ navigation }) => {
  const [dataChallenges, setDataChallenges] = useState([]);
  const { workerData } = useSelector((state) => state.worker);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getChallenges();
  }, []);

  const getChallenges = async () => {
    API.post('/search/desafio', {
      where: `id_empresa = "${workerData.id_empresa}" AND id_setor = "${workerData.id_setor}"`,
    }).then(async (res) => {
      const response = res.data.data;
      const resolve = Promise.all(response.map(async (item, index) => {
        const date = new Date(item.fim).toLocaleDateString('pt-BR');
        if (item.personalizado) {
          const sucess = await API.post('/search/colaborador_desafio', {
            where: `id_colaborador = "${workerData.id_colaborador}" AND id_desafio = "${item.id_desafio}"`,
          }).then((res_challenge) => (!!res_challenge.data.data[0]));
          return {
            id_app: index,
            index: item.titulo,
            limit: date,
            value: item.moedas,
            custom: true,
            titulo: item.titulo,
            sucess,
            goals: [],
          };
        }
        const searchClasses = await API.post('/search/desafio_aula', {
          where: `id_desafio = "${item.id_desafio}"`,
        }).then(async (classes) => {
          const lessonAndClass = await Promise.all(classes.data.data.map(async (iClass) => {
            const lesson = await API.get(`/get/aula/${iClass.id_aula}`);
            const completedClass = await API.post('/search/colaborador_aula', {
              where: `id_colaborador = "e17e2da98f3222b9221449b787e00003" AND id_aula="${iClass.id_aula}"`,
            });
            return {
              completed: !!completedClass.data.data[0],
              description: lesson.data.data[0].titulo,
            };
          }));
          return lessonAndClass;
        });
        return {
          id_app: index,
          index: item.titulo,
          limit: date,
          value: item.moedas,
          custom: false,
          goals: [...searchClasses],
        };
      }));
      setDataChallenges(await resolve);
      setLoading(false);
    });
  };

  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <AppHeader title="Desafios Leths Wellness" />
      <View style={styles.content}>
        {/* <AppText style={{ fontSize: pixelDimensions(8), textAlign: 'center', fontFamily: 'MBold' }}>Aguarde novos desafios</AppText> */}
        {loading ? <ActivityIndicator size="large" color={appColors.primary} />
          : (
            <ScrollView>
              {!!dataChallenges.length && dataChallenges.map(({
                index, goals, limit, value, custom, sucess,
              }) => (
                <View key={index}>
                  <View style={styles.viewChallengeBase}>
                    <View style={{ flex: 1, paddingVertical: pixelDimensions(2), paddingHorizontal: pixelDimensions(4) }}>

                      <AppText style={{
                        color: Colors.white, fontSize: pixelDimensions(5), textAlign: 'center', justifyContent: 'center',
                      }}
                      >
                        {index }
                      </AppText>

                      {custom === false && (
                      <View style={{ flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>

                        <AppText style={{ color: Colors.white, fontSize: pixelDimensions(9) }}>
                          { goals?.filter((goal) => goal.completed === true).length }
                          /
                          {goals?.length}
                        </AppText>

                        <Icon name="trophy" style={{ color: Colors.yellow500, fontSize: pixelDimensions(12) }} />
                      </View>
                      )}
                      <View style={{ alignItems: 'center' }}>
                        {custom === false && (
                        <AppText style={{ color: Colors.white, fontSize: pixelDimensions(3.5) }}>Desafios Concluídos</AppText>
                        )}
                        <AppText style={{ color: Colors.white, fontSize: pixelDimensions(3.5) }}>
                          Meta:
                          {' '}
                          {limit}
                        </AppText>
                      </View>
                    </View>
                    <View style={{
                      flex: 1, padding: pixelDimensions(2), paddingHorizontal: pixelDimensions(4), justifyContent: 'center', alignItems: 'center',
                    }}
                    >
                      <AppText size="bold" style={{ textAlign: 'center', color: Colors.white, fontSize: pixelDimensions(7) }}>
                        Vale
                        {' '}
                        {value}
                        {' '}
                        Moedas
                      </AppText>
                      <AppText style={{ color: Colors.white, fontSize: pixelDimensions(3.5) }}>Após concluir tudo!</AppText>
                      {custom && (
                      <AppText style={{ color: Colors.white, marginTop: pixelDimensions(2), fontSize: pixelDimensions(3.5) }}>
                        Status:
                        {' '}
                        {sucess ? 'Concluido' : 'Por Fazer'}
                      </AppText>
                      )}
                    </View>
                  </View>
                  <View style={styles.viewChallengeList}>
                    {
                                        !!goals.length && goals.map(({ completed, description }) => (
                                          <View key={Math.random()} style={{ flexDirection: 'row', alignItems: 'center' }}>
                                            <Icon name="trophy-outline" style={{ color: completed ? Colors.green500 : Colors.red500, fontSize: pixelDimensions(15) }} />
                                            <AppText style={{ paddingLeft: pixelDimensions(2), fontSize: pixelDimensions(4), textAlign: 'justify' }}>{description}</AppText>
                                          </View>
                                        ))
                                    }
                  </View>
                </View>

              ))}
            </ScrollView>
          )}
      </View>
    </ImageBackground>
  );
};

export default Challenges;
